import { WindowLocation } from '@gatsbyjs/reach-router'
import { useContext } from 'react'

import { LocationContext } from '../context'

/**
 * The page's location, mirrored into context for consumers mounted in `wrapRootElement` —
 * `GlobalSubscriptions`, `ToggleCartContextProvider` and the global toasts all sit above Gatsby's
 * router, so reach-router's own `useLocation` has no provider to read from there.
 *
 * `null` until `LocationContextUpdate` has run its effect, which is one render behind the navigation
 * and cannot be otherwise. A caller inside the page tree should use reach-router's `useLocation`
 * instead (see `useDispensarySlug`), since that is right on the first render. The distinction decides
 * correctness wherever the value is captured into a closure that outlives its render, because a later
 * update never reaches one.
 */
export const useLocationContext = (): WindowLocation | null => {
  const { location } = useContext(LocationContext)
  return location
}
